import { Component } from '@theme/component';

export class ExclusiveOffer extends Component {
  errors = {
    required: 'This is required field.',
    invalid: 'Please enter a valid email.',
  }
  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  success = false;
  loading = false;
  showModal = false;

  offerText = this.dataset.offerText || '';
  productName = this.dataset.productName || '';
  productImage = this.dataset.productImage || '';

  toggleBtn = this.querySelector('.exclusive-offer-button');
  modal = document.querySelector('dialog-component#exclusive-offer-modal');
  content = null;
  email = null;
  error = null;
  newsletter = null;
  submitBtn = null;

  connectedCallback() {
    super.connectedCallback();

    this.toggleBtn?.addEventListener('click', e => {
      e.preventDefault();
      this.#ensureContent();
      this.classList.toggle('active');
    });
  }

  #ensureContent() {
    if (this.content) return;

    const host = this.closest('product-form-component');

    if (!host) return;

    let content = host.querySelector('.exclusive-offer-content');

    if (!content) {
      const template = document.getElementById('exclusive-offer-form-template');

      if (!(template instanceof HTMLTemplateElement)) return;

      host.appendChild(template.content.cloneNode(true));
      content = host.querySelector('.exclusive-offer-content');
    }

    if (!content) return;

    this.content = content;
    this.email = content.querySelector('input#email');
    this.error = content.querySelector('#email-error');
    this.newsletter = content.querySelector('input#newsletter');
    this.submitBtn = content.querySelector('button[type="submit"]');
    this.submitBtn?.addEventListener('click', this.submit.bind(this));
  }

  /**
   *
   * @param {Event} e
   */
  async submit(e) {
    e.preventDefault();

    const emailValue = this.email?.value;

    if (!this.email || !emailValue) {
      if (this.error) {
        this.error.textContent = this.errors.required;
        this.error?.classList.add('active');
      }

      return;
    }

    if (!this.isEmailValid(emailValue)) {
      if (this.error) {
        this.error.textContent = this.errors.invalid;
        this.error?.classList.add('active');
      }

      return;
    }

    if (this.loading) return;

    try {
      this.loading = true;
      this.error?.classList.remove('active');
      this.submitBtn?.setAttribute('disabled', 'disabled');

      if (this.newsletter.checked) {
        await this.subscribe();
      }

      await this.sendEvent();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
      this.email.value = '';
      this.modal?.toggleDialog();
      this.classList.remove('active');
      this.submitBtn?.removeAttribute('disabled');
    }
  }

  async subscribe() {
    return new Promise(resolve => {
      document.dispatchEvent(new CustomEvent('aw-klaviyo:subscribe', {
        detail: {
          email: this.email.value,
          callback: () => resolve(true)
        }
      }));
    });
  }

  async sendEvent() {
    return new Promise(resolve => {
      document.dispatchEvent(new CustomEvent('aw-klaviyo:send-event', {
        detail: {
          email: this.email.value,
          content: this.offerText,
          productName: this.productName,
          productImage: this.productImage,
          callback: () => resolve(true)
        }
      }));
    });
  }

  /**
   *
   * @param {String} email
   */
  isEmailValid(email) {
    return this.emailRegex.test(email);
  }
}

if (!customElements.get('exclusive-offer')) {
  customElements.define('exclusive-offer', ExclusiveOffer);
}
